import {
    RequestConfigFunction,
} from 'app/types/request.types'
import {
    WithId,
} from 'app/types/common.types'
import {
    LongTermLeaseInvoiceFilterResponse, LongTermLeaseInvoicePositionType,
    LongTermLeaseInvoiceResponse,
    LongTermLeaseInvoiceType,
    LongTermLeaseInvoiceUpdateRequest,
} from './LongTermLeaseInvoice.types'

type LongTermLeaseInvoiceRequests = {
    get: RequestConfigFunction<WithId<number>, LongTermLeaseInvoiceResponse>,
    update: RequestConfigFunction<WithId<number>>,
    archive: RequestConfigFunction<WithId<number>>,
    restore: RequestConfigFunction<WithId<number>>,
    sapSending: RequestConfigFunction<{longTermLeaseInvoiceId: number}>,
    filterRequestAll: RequestConfigFunction<{
        params?: Record<string, any>,
    }, LongTermLeaseInvoiceFilterResponse>,
    filterRequestCount: RequestConfigFunction<{
        fieldName: string,
    }>,
    createPosition: RequestConfigFunction<{longTermLeaseInvoiceId: number}>,
    positionFilterRequestAll: RequestConfigFunction<{
        longTermLeaseInvoiceId: number,
        params?: Record<string, any>,
    }, LongTermLeaseInvoicePositionType>,
    getLongTermLeaseInvoice: RequestConfigFunction<
        {longTermLeaseInvoiceId: number}, LongTermLeaseInvoiceType>,
    archiveLongTermLeaseInvoice: RequestConfigFunction<{longTermLeaseInvoiceId: number}>,
    updateLongTermLeaseInvoice: RequestConfigFunction<{
        longTermLeaseInvoiceId: number,
        data?: LongTermLeaseInvoiceUpdateRequest,
    }>,
}

const longTermLeaseInvoiceRequests: LongTermLeaseInvoiceRequests = {
    restore: ({
        id,
    }) => {
        return {
            url: `longtermleaseinvoice/${id}/restore`,
            method: 'PATCH',
        }
    },
    sapSending: ({
        longTermLeaseInvoiceId,
    }) => {
        return {
            url: `longtermleaseinvoice/${longTermLeaseInvoiceId}/sap-sending`,
            method: 'PATCH',
        }
    },
    filterRequestAll: ({
        params,
    } = {}) => {
        return {
            url: 'longtermleaseinvoice/filter-request/all',
            method: 'POST',
            ...params,
        }
    },
    filterRequestCount: ({
        fieldName,
    }) => {
        return {
            url: `longtermleaseinvoice/filter-request/all/count/${fieldName}`,
            method: 'POST',
        }
    },
    createPosition: ({
        longTermLeaseInvoiceId,
    }) => {
        return {
            url: `longtermleaseinvoice/${longTermLeaseInvoiceId}/position`,
            method: 'POST',
        }
    },
    positionFilterRequestAll: ({
        longTermLeaseInvoiceId,
        params,
    }) => {
        return {
            url: `longtermleaseinvoice/${longTermLeaseInvoiceId}/position/filter-request/all`,
            method: 'POST',
            ...params,
        }
    },
    getLongTermLeaseInvoice: ({
        longTermLeaseInvoiceId,
    }) => {
        return {
            url: `longtermleaseinvoice/${longTermLeaseInvoiceId}`,
            method: 'GET',
        }
    },
    archiveLongTermLeaseInvoice: ({
        longTermLeaseInvoiceId,
    }) => {
        return {
            url: `longtermleaseinvoice/${longTermLeaseInvoiceId}/archive`,
            method: 'PATCH',
        }
    },
    updateLongTermLeaseInvoice: ({
        longTermLeaseInvoiceId,
        data,
    }) => {
        return {
            url: `longtermleaseinvoice/${longTermLeaseInvoiceId}`,
            method: 'PATCH',
            data,
        }
    },
}

export default longTermLeaseInvoiceRequests
